module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sponsor) ? _c('div', {
    staticClass: "list-item",
    class: {
      'list-item-payment-complete': _vm.s.participationStatus === 'Paid'
    }
  }, [_c('div', {
    staticClass: "left-part"
  }, [_c('span', {
    staticClass: "icon",
    class: {
      'icon-checkmark': _vm.s.participationStatus === 'Paid',
        'icon-notification': _vm.s.participationStatus === 'Participates',
        'icon-question': _vm.s.participationStatus === 'NotAnswered' || _vm.s.participationStatus === 'Refused'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-part"
  }, [_c('div', {
    staticClass: "information-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.s.fullName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.s.email))]), _vm._v(" "), (_vm.s.participationStatus === 'NotAnswered' && _vm.s.invitedOn) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.invitedOn", [_vm.dateDisplay(_vm.s.invitedOn)])))])]) : _vm._e(), _vm._v(" "), (_vm.s.participationStatus === 'Participates' || _vm.s.participationStatus === 'Paid') ? _c('div', [(_vm.s.paymentMethod === 'PerRepeat') ? _c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.paymentPerRepeat", [_vm.s.payment])))]) : (_vm.s.paymentMethod === 'Manual') ? _c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.paymentManual", [_vm.s.payment])))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "action-block"
  }, [(_vm.canSendBill && !_vm.s.billSentOn && _vm.s.participationStatus == 'Participates') ? [(_vm.s.participationStatus == 'Participates') ? _c('div', [_c('button', {
    staticClass: "button button-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('bill', _vm.s)
      }
    }
  }, [_vm._v("\r\n                        " + _vm._s(_vm.$t("sponsorsView.sendBill")) + "\r\n                    ")])]) : _vm._e()] : [(_vm.s.participationStatus === 'Participates' && _vm.isNotificationAllowed(_vm.s)) ? _c('button', {
    staticClass: "button button-small",
    attrs: {
      "disabled": !_vm.s.billSentOn || _vm.s.sendingEmail
    },
    on: {
      "click": function($event) {
        _vm.$emit('reminder', _vm.s)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-bell"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.sendReminder")))])]) : _vm._e(), _vm._v(" "), (_vm.s.participationStatus === 'Participates' && !_vm.isNotificationAllowed(_vm.s)) ? _c('div', [(_vm.isNotificationAllowed(_vm.s)) ? _c('span', {
    staticClass: "icon icon-bell"
  }) : _vm._e(), _vm._v(" "), (_vm.s.notificationSentOn) ? _c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.reminderSent", [_vm.dateDisplay(_vm.s.notificationSentOn)])))]) : (_vm.s.billSentOn) ? _c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.billSent", [_vm.dateDisplay(_vm.s.billSentOn)])))]) : _vm._e()]) : (_vm.s.participationStatus === 'Paid') ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.paymentCompleted")))])]) : (_vm.s.participationStatus === 'NotAnswered' && _vm.isInvitationAllowed(_vm.s)) ? _c('button', {
    staticClass: "button button-small",
    attrs: {
      "disabled": _vm.s.sendingEmail
    },
    on: {
      "click": function($event) {
        _vm.$emit('reInvite', _vm.s)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-mail4"
  }), _vm._v(" "), (_vm.s.invitedOn) ? _c('span', [_vm._v(_vm._s(_vm.$t("sponsorsView.inviteAgain")))]) : _vm._e()]) : _vm._e()]], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ab08fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/SponsorListItem.vue
// module id = 120
// module chunks = 0